/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */


import React, { Component } from 'react';
import { Card, CardDeck, CardBody, Col, Button } from 'reactstrap';
import { PDFDownloadLink, Document, Page, Text, StyleSheet, View, Link } from '@react-pdf/renderer';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import axios from 'axios';
import { connect } from 'react-redux';
import { countryList, isDomesticShipment } from '../../../../../../helpers/shipping/CountriesNew';
import SubmitBatchButton from './SubmitBatchButton';
import { domesticServices, internationalServices } from '../../../../../../helpers/shipping/AbdServices';
import { getServicePrice, getMMServicePrice, isTaxable, getShippingZone, getAvailableTrackedService } from '../../../../../../helpers/shipping/AbdPricer';

const currencyFormat = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
const URL = 'https://api.musicmarquee.co.uk';

let MyDoc;

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
  section: {
    margin: 10,
    padding: 0,
    borderBottomStyle: 'solid',
    borderBottomColor: 'black',
    borderBottomWidth: 1,
  },
  multipleSplitSection: {
    padding: 0,
    borderBottomStyle: 'solid',
    borderBottomColor: 'black',
    borderBottomWidth: 4,
  },
  header: {
    fontSize: 18,
    textAlign: 'center',
    // color: 'red',
  },
  subHeader: {
    fontSize: 14,
    textAlign: 'center',
    // color: 'red',

  },
  subSubHeader: {
    fontSize: 12,
    textAlign: 'center',
    // color: 'red',

  },
  text: {
    fontSize: 14,
    // color: 'red',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    margin: 5,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },
  tableCol: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    margin: 'auto',
    marginTop: 5,
    fontSize: 10,
    // color: 'red',
  },
  multipleHeaderCell: {
    margin: 'auto',
    marginTop: 5,
    fontSize: 10,
    // color: 'red',
  },
});

const getColumnWidth = (rows, accessor, headerText) => {
  if (rows !== undefined) {
    const maxWidth = 400;
    let magicSpacing = 10;
    switch (accessor) {
      case 'total':
        magicSpacing += 3;
        break;
      case 'seller_id':
        magicSpacing += 10;
        break;
      case 'pull_sheet':
        magicSpacing += 5;
        break;
      default:
    }
    const cellLength = Math.max(
      ...rows.map(row => (`${row[accessor]}` || '').length),
      headerText.length,
    );
    return Math.min(maxWidth, cellLength * magicSpacing);
  }
  return null;
};

const getDomesticServiceForSize = (service, size) => {
  if (service === 'TPS' && size === 'LL') {
    return 'TRS';
  }

  if (service === 'TRS' && size === 'SP') {
    return 'TPS';
  }

  return service;
};

// const currencyFormat = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' })

class OpenOrdersTable extends Component {
  constructor() {
    super();
    this.state = {
      pages: 2,
      loading: false,
      groupedData: [],
      data: [],
      selectedGroup: undefined,
      selected: undefined,
      // selectedActWeight: null,
      // selectedActualPrice: null,
      // selectedMMPrice: null,
      shipmentBatch: [],
      isEditing: false,
      // selectedSize: null,
      clients: [],
      advancedFilters: {
        clientId: '',
        clientMode: 'include', // include | exclude
        labelId: '',
        quantityMin: '',
        quantityMax: '',
        sku: '',
        paymentId: '',
        shippingNote: '',
        waitNoteMode: 'hide',
      },
    };
    this.getGroupedOrders();
  }

  componentDidMount() {
    this.getClients();
  }

  async getClients() {
    try {
      const response = await axios.post(
        `${URL}/admin/bandcamp/filter-clients`,
        {},
        {
          headers: {
            Authorization: localStorage.getItem('mm_admin'),
          },
        },
      );

      console.log('CLIENT FILTER RESPONSE:', response.data);

      this.setState({
        clients: response.data.clients || [],
      });
    } catch (error) {
      console.log('CLIENT FILTER ERROR:', error);
    }
  }

  getLocallyFilteredOrders = (orders) => {
    const {
      sku,
      quantityMin,
      quantityMax,
    } = this.state.advancedFilters;

    let filteredOrders = [...orders];

    const outOfStockPaymentIds = new Set(filteredOrders
      .filter(order => Number(order.mm_quantity || 0) < 1)
      .map(order => order.payment_id));

    filteredOrders = filteredOrders.filter(order =>
      !outOfStockPaymentIds.has(order.payment_id));

    if (sku) {
      const skuSearch = sku.toLowerCase();

      const matchingPaymentIds = new Set(filteredOrders
        .filter(order =>
          `${order.sku || ''}`.toLowerCase().includes(skuSearch))
        .map(order => order.payment_id));

      filteredOrders = filteredOrders.filter(order =>
        matchingPaymentIds.has(order.payment_id));
    }

    if (quantityMin || quantityMax) {
      const quantityByPaymentId = filteredOrders.reduce((totals, order) => {
        if (!totals[order.payment_id]) {
          totals[order.payment_id] = 0;
        }

        totals[order.payment_id] += Number(order.quantity || 0);

        return totals;
      }, {});

      filteredOrders = filteredOrders.filter((order) => {
        const totalQuantity = quantityByPaymentId[order.payment_id];

        if (quantityMin && totalQuantity < Number(quantityMin)) {
          return false;
        }

        if (quantityMax && totalQuantity > Number(quantityMax)) {
          return false;
        }

        return true;
      });
    }

    return filteredOrders;
  };

  getAddressIssues = (order) => {
    const issues = [];
    if (order.ship_to_name.length > 30) issues.push('Name >30 Ch');
    if (order.ship_to_state && order.ship_to_state.length > 20) issues.push('State > 20 Ch');
    if (order.ship_to_street.length > 40) issues.push('Address1 > 40 Ch');
    if (order.ship_to_street_2 && order.ship_to_street_2.length > 40) issues.push('Address2 > 40 Ch');
    if (order.ship_to_city.length > 30) issues.push('City > 30 Ch');
    // if (!this.isValidUKPostcode(order.ship_to_Zip)) issues.push('Invalid Postcode');


    // if (!address.address1) issues.push('Missing address line 1');
    // if (!address.city) issues.push('Missing city');
    // if (!address.zip) issues.push('Missing postcode');
    // if (!address.country_code) issues.push('Missing country');

    // if (address.address1 && address.address1.length > 40) {
    //   issues.push('Address line 1 too long');
    // }

    // if (address.address2 && address.address2.length > 40) {
    //   issues.push('Address line 2 too long');
    // }

    // if (address.name && address.name.length > 35) {
    //   issues.push('Name too long');
    // }

    return issues;
  };

  async getGroupedOrders() {
    const serverFilters = {
      clientId: this.state.advancedFilters.clientId,
      clientMode: this.state.advancedFilters.clientMode,
      paymentId: this.state.advancedFilters.paymentId,
      shippingNote: this.state.advancedFilters.shippingNote,
      waitNoteMode: this.state.advancedFilters.waitNoteMode,
    };
    const response = await axios.post(`${URL}/admin/bandcamp/orders/open`, {
      page: 1,
      pageSize: 1000,
      sorted: null,
      filtered: null,
      filters: serverFilters,
    }, { headers: { Authorization: localStorage.getItem('mm_admin') } });

    const locallyFilteredOrders = this.getLocallyFilteredOrders(response.data.orders)
      .map(order => ({
        ...order,
        address_issues: this.getAddressIssues(order),
      }));
    const grouped = locallyFilteredOrders.filter(orderDest => isDomesticShipment(orderDest.ship_to_country_code, orderDest.ship_to_zip)).reduce((groups, order) => {
    // const grouped = response.data.orders.reduce((groups, order) => {
      if (response.data.orders.filter(filterOrder => filterOrder.payment_id === order.payment_id).length > 1) {
        const hasPreOrder = response.data.orders.filter(filterOrder => filterOrder.payment_id === order.payment_id).filter(filterOrder2 => filterOrder2.is_preorder === true).length > 0;
        const outOfStock = response.data.orders.filter(filterOrder => filterOrder.payment_id === order.payment_id).filter(filterOrder2 => filterOrder2.mm_quantity < 1).length > 0;

        const itemsInOrder = response.data.orders.filter(filterOrder => filterOrder.payment_id === order.payment_id);
        let toSend = true;
        const totalItems = itemsInOrder.map(item => item.quantity).reduce((prev, curr) => prev + curr, 0);
        if (totalItems > 55) {
          toSend = false;
        }


        order.is_preorder = hasPreOrder;
        if (hasPreOrder || !toSend) {
          if (!groups['Multiple Items (Pre-Order)']) groups['Multiple Items (Pre-Order)'] = [];
          groups['Multiple Items (Pre-Order)'].push(order);
        } else if (outOfStock) {
          if (!groups['Multiple Items (Out of Stock)']) groups['Multiple Items (Out of Stock)'] = [];
          groups['Multiple Items (Out of Stock)'].push(order);
        } else {
          if (!groups['Multiple Items']) groups['Multiple Items'] = [];
          groups['Multiple Items'].push(order);
        }
        // groups['Multiple Items'].push(response.data.orders.find(filterOrder =>
        //   filterOrder.payment_id === order.payment_id));
      } else {
        const title = `${order.album_title ? `${order.album_title}:` : ''} ${order.title} by ${order.artist}`;
        if (!groups[title]) groups[title] = [];
        groups[title].push(order);
      }
      return groups;
    }, {});

    const group2 = [];
    Object.keys(grouped).forEach((key) => {
      let orderType = '';
      if (grouped[key].filter(filterOrder => filterOrder.is_preorder === true).length > 0) {
        orderType = 'Pre-Order';
      } else if (grouped[key].filter(filterOrder => filterOrder.mm_quantity < 1).length > 0) {
        orderType = 'Out of Stock';
      } else {
        orderType = 'Ready';
      }

      const addressIssues = grouped[key]
        .reduce((issues, order) => {
          if (order.address_issues && order.address_issues.length > 0) {
            return issues.concat(order.address_issues);
          }

          return issues;
        }, []);

      const client = this.state.clients.find(findClient =>
        findClient.id === grouped[key][0].client_id);
      const obj = {
        item: key,
        orders: grouped[key],
        clientName: client ? client.name : grouped[key][0].client_id,
        orderType,
      };
      group2.push(obj);
    });
    this.setState({
      groupedData: group2,
      selected: undefined,
    });
  }

    isValidUKPostcode = (postcode) => {
      const regex =
        /^(GIR 0AA|[A-PR-UWYZ][A-HK-Y]?\d[A-HJKPSTUW\d]?\s?\d[ABD-HJLNP-UW-Z]{2})$/i;

      return regex.test(postcode.trim().toUpperCase());
    }

    handleSelectedAddressChange = (field, value) => {
      const selected = {
        ...this.state.selected,
        [field]: value,
      };

      selected.address_issues = this.getAddressIssues(selected);

      const updateMatchingOrder = (order) => {
        if (order.payment_id !== selected.payment_id) {
          return order;
        }

        const updatedOrder = {
          ...order,
          [field]: value,
        };

        updatedOrder.address_issues = this.getAddressIssues(updatedOrder);
        return updatedOrder;
      };

      const data = this.state.data.map(updateMatchingOrder);

      const groupedData = this.state.groupedData.map((group) => {
        const orders = group.orders.map(updateMatchingOrder);

        const addressIssues = orders.reduce((issues, order) => {
          if (order.address_issues && order.address_issues.length > 0) {
            return issues.concat(order.address_issues);
          }

          return issues;
        }, []);

        return {
          ...group,
          orders,
          hasAddressIssues: addressIssues.length > 0,
          addressIssues,
        };
      });

      this.setState({
        selected,
        data,
        groupedData,
      });
    };

  removeOrdersWithOutOfStockItems = (orders) => {
    const outOfStockPaymentIds = new Set(orders
      .filter(order => Number(order.mm_quantity || 0) < 1)
      .map(order => order.payment_id));

    return orders.filter(order =>
      !outOfStockPaymentIds.has(order.payment_id));
  };

  handleAdvancedFilterChange = async (field, value) => {
    const updatedFilters = {
      ...this.state.advancedFilters,
      [field]: value,
    };

    await this.setState({
      advancedFilters: updatedFilters,
    });

    this.getGroupedOrders();
  };

  async submitPrepareBatch(group) {
    if (group.item === 'Multiple Items' || group.item === 'Multiple Items (Pre-Order)') {
      const orders = [];
      const grouped = group.orders.reduce((groups, order) => {
        if (group.orders.filter(filterOrder => filterOrder.payment_id === order.payment_id).length > 1) {
          if (!groups[order.payment_id]) groups[order.payment_id] = [];
          groups[order.payment_id].push(order);
        }
        return groups;
      }, {});

      Object.keys(grouped).forEach((key) => {
        orders.push(grouped[key]);
      });

      const ordersToPush = [];

      orders.map((groupOrders) => {
        let service = '';
        let mmSize = 'SP';
        let toTrack = false;
        groupOrders.map((groupOrder) => {
          if (groupOrder.sku === 'VRADE19') {
            toTrack = true;
          }
          if (groupOrders[0].package_size === 'LL' && groupOrder.package_size === 'SP') {
            groupOrders[0].package_size = 'SP';
          }
        });
        if (isDomesticShipment(groupOrders[0].ship_to_country_code, groupOrders[0].ship_to_zip)) {
          service = 'TPS';
          if (groupOrders[0].package_size === 'LL') {
            mmSize = 'LL';
            service = 'TRS';
          }
          if (toTrack) {
            service = 'CRL24S';
          }
        } else {
          if (groupOrders[0].package_size === 'SP') {
            service = 'IE1';
            mmSize = 'SP';
          } else if (groupOrders[0].package_size === 'LL') {
            service = 'IG1';
            mmSize = 'LL';
          }
          if (toTrack) {
            service = getAvailableTrackedService(groupOrders[0].ship_to_country, groupOrders[0].package_size);
          }
        }
        // console.log(service);
        // console.log(groupOrders[0].ship_to_country);
        // console.log(toTrack);
        // console.log();
        groupOrders[0].shipping_service = service;
        groupOrders[0].mm_package_size = mmSize;
        let totalValue = 0.00;
        groupOrders.map((order) => {
          totalValue += parseFloat(order.sub_total);
        });
        ordersToPush.push({
          payment_id: groupOrders[0].payment_id,
          client_id: groupOrders[0].client_id,
          sub_total: totalValue,
          shipping_service: service,
          mm_package_size: mmSize,
          package_size: groupOrders[0].package_size,
        });
      });
      const group2 = {};
      group2.orders = ordersToPush;
      await axios.post(`${URL}/admin/bandcamp/orders/prepare`, {
        group2,
      }, { headers: { Authorization: localStorage.getItem('mm_admin') } })
        .then((res) => {
        // Update react-table
          const groupCopy = this.state.selectedGroup;
          res.data.orders.map((resOrder) => {
            const groupOrders = groupCopy.orders.filter(findOrder =>
              findOrder.payment_id.toString() === resOrder.payment_id.toString());
            groupOrders.map((groupOrder) => {
              groupOrder.fulfilment_status = resOrder.status;
              groupOrder.fulfilment_id = resOrder.id;
              groupOrder.shipping_service = resOrder.shipping_service;
              groupOrder.package_size = resOrder.package_size;
            });
          });
          this.setState({ selectedGroup: groupCopy });
        });
    } else {
      const orders = [];

      group.orders.map((order) => {
        let service = '';
        let mmSize = 'SP';
        if (isDomesticShipment(order.ship_to_country_code, order.ship_to_zip)) {
          service = 'TPS';
          if (order.package_size === 'LL') {
            mmSize = 'LL';
            service = 'TRS';
          }
          if (order.sku === 'VRADE19') {
            service = 'CRL24S';
          }
        } else {
          if (order.package_size === 'SP') {
            service = 'IE1';
            mmSize = 'SP';
          } else if (order.package_size === 'LL') {
            service = 'IG1';
            mmSize = 'LL';
          }
          if (order.sku === 'VRADE19') {
            service = getAvailableTrackedService(order.ship_to_country, order.package_size);
          }
        }
        order.shipping_service = service;
        order.mm_package_size = mmSize;

        orders.push({
          payment_id: order.payment_id,
          client_id: order.client_id,
          package_id: order.package_id,
          sub_total: order.sub_total,
          shipping_service: service,
          mm_package_size: mmSize,
          package_size: order.package_size,
        });
      });
      const group2 = {};
      group2.orders = orders;
      await axios.post(`${URL}/admin/bandcamp/orders/prepare`, {
        group2,
      }, { headers: { Authorization: localStorage.getItem('mm_admin') } })
        .then((res) => {
        // Update react-table
          const groupCopy = this.state.selectedGroup;
          res.data.orders.map((resOrder) => {
            const groupOrder = groupCopy.orders.find(findOrder =>
              findOrder.payment_id.toString() === resOrder.payment_id.toString());
            groupOrder.fulfilment_status = resOrder.status;
            groupOrder.fulfilment_id = resOrder.id;
            groupOrder.shipping_service = resOrder.shipping_service;
            groupOrder.package_size = resOrder.package_size;
          });
          this.setState({ selectedGroup: groupCopy });
        });
    }
    return true;
  }

  async submitShipmentBatch(row) {
    const smallPackage = 50;
    const mediumPackage = 310;
    const largePackage = 310;

    if (row.item === 'Multiple Items' || row.item === 'Multiple Items (Pre-Order)') {
      const orders = [];
      const grouped = row.orders.reduce((groups, order) => {
        if (row.orders.filter(filterOrder => filterOrder.payment_id === order.payment_id && filterOrder.fulfilment_status === 'Preparing').length > 1) {
          if (!groups[order.payment_id]) groups[order.payment_id] = [];
          groups[order.payment_id].push(order);
        }
        return groups;
      }, {});

      Object.keys(grouped).forEach((key) => {
        orders.push(grouped[key]);
      });

      const filteredOrders = [];
      const itemsForUpdate = [];
      orders.map((groupOrders) => {
        if (groupOrders[0].fulfilment_status === 'Preparing' && filteredOrders.length <= 35) {
          groupOrders[0].packaging_fee = 0.30;
          groupOrders[0].order_fee = 1.00;

          let totalWeight = groupOrders.map(order => order.mm_weight * order.quantity).reduce((prev, curr) => prev + curr, 0);
          groupOrders[0].customsItems = [];

          groupOrders.map((order) => {
            const customsItem = {};
            // const nameCheck = order.item_name.toString().toLowerCase();

            // if (nameCheck.includes('cd')) {
            //   customsItem.itemDesc = 'CD';
            //   customsItem.itemHs = 8523492000;
            // } else if (nameCheck.includes('poster')) {
            //   customsItem.itemDesc = 'Poster';
            //   customsItem.itemHs = 4901990000;
            // } else if (nameCheck.includes('cassette')) {
            //   customsItem.itemDesc = 'Cassette Tape';
            //   customsItem.itemHs = 8523291900;
            // } else if (nameCheck.includes('tee')) {
            //   customsItem.itemDesc = 'T-Shirt';
            //   customsItem.itemHs = 6109100010;
            // } else if (nameCheck.includes('sweatshirt')) {
            //   customsItem.itemDesc = 'Sweatshirt';
            //   customsItem.itemHs = 6109100010;
            // } else {
            //   customsItem.itemDesc = 'Vinyl Record';
            //   customsItem.itemHs = 8523809000;
            // }
            customsItem.itemName = order.item_name;
            customsItem.itemOrigin = order.customs_origin;
            customsItem.itemDesc = order.customs_desc;
            customsItem.itemHs = order.hs_code;
            customsItem.itemQty = order.quantity;
            customsItem.itemPrice = order.price;
            customsItem.itemWeight = order.mm_weight;
            groupOrders[0].customsItems.push(customsItem);
          });
          if (groupOrders[0].package_size === 'SP') {
            if (groupOrders.map(orderCount => orderCount.quantity).reduce((prev, curr) => prev + curr, 0) > 3) {
              totalWeight += largePackage;
              groupOrders[0].packaging_fee = 0.60;
            } else {
              totalWeight += mediumPackage;
            }
          } else {
            totalWeight += smallPackage;
          }
          if (totalWeight > 1999 && isDomesticShipment(groupOrders[0].ship_to_country_code, groupOrders[0].ship_to_zip)) {
            groupOrders[0].shipping_service = 'TPS';
          }
          // if (totalWeight > 1999 && groupOrders[0].ship_to_country_code !== 'GB') {
          //   totalWeight = 1999;
          // }
          groupOrders[0].mm_weight = totalWeight;
          groupOrders[0].mm_package_size = groupOrders[0].package_size === 'LL' && totalWeight <= 749 ? 'LL' : 'SP';
          if (groupOrders[0].mm_package_size === 'SP') {
            groupOrders[0].packaging_fee = 0.60;
          }
          if (isDomesticShipment(groupOrders[0].ship_to_country_code, groupOrders[0].ship_to_zip)) {
            groupOrders[0].shipping_service = getDomesticServiceForSize(groupOrders[0].shipping_service, groupOrders[0].mm_package_size);
          }
          const servicePrice = getServicePrice(groupOrders[0].mm_weight, groupOrders[0].shipping_service, groupOrders[0].ship_to_country, groupOrders[0].mm_package_size);
          const mmPrice = getMMServicePrice(groupOrders[0].mm_weight, groupOrders[0].shipping_service, groupOrders[0].ship_to_country, groupOrders[0].mm_package_size);
          const shippingZone = getShippingZone(groupOrders[0].ship_to_country);
          groupOrders[0].shipping_zone = shippingZone;
          groupOrders[0].mm_shipping_cost = mmPrice;
          groupOrders[0].client_shipping_price = servicePrice;
          groupOrders[0].fee_vat = (groupOrders[0].packaging_fee + groupOrders[0].order_fee) * 0.2;
          if (isTaxable(groupOrders[0].ship_to_country)) {
            groupOrders[0].shipping_vat = groupOrders[0].client_shipping_price * 0.2;
          } else {
            groupOrders[0].shipping_vat = 0;
          }
          const country = countryList.find(ctry => ctry.label === groupOrders[0].ship_to_country);
          groupOrders[0].ship_to_countrycode = country.value;
          if (groupOrders[0].mm_weight > 1999) {
            if (isDomesticShipment(groupOrders[0].ship_to_country_code, groupOrders[0].ship_to_zip)) {
              filteredOrders.push(groupOrders[0]);
              groupOrders.map((groupOrder) => {
                if (!itemsForUpdate.some(item => item.package_id === groupOrder.package_id)) itemsForUpdate.push({ package_id: groupOrder.package_id, sku: groupOrder.sku, qty: 0 });
                itemsForUpdate.find(item => item.package_id === groupOrder.package_id).qty += groupOrder.quantity;
              });
            }
          } else {
            filteredOrders.push(groupOrders[0]);
            groupOrders.map((groupOrder) => {
              if (!itemsForUpdate.some(item => item.package_id === groupOrder.package_id)) itemsForUpdate.push({ package_id: groupOrder.package_id, sku: groupOrder.sku, qty: 0 });
              itemsForUpdate.find(item => item.package_id === groupOrder.package_id).qty += groupOrder.quantity;
            });
          }
        }
      });
      filteredOrders.map((item, index) => {
        item.batchPosition = index;
      });
      await axios.post(`${URL}/admin/bandcamp/orders/ship`, {
        orders: filteredOrders,
        items_to_update: itemsForUpdate,
      }, {
        headers: {
          Authorization: localStorage.getItem('mm_admin'),
          'Content-Type': 'application/json',
          Accept: 'application/pdf',
        },
        responseType: 'arraybuffer',
      })
        .then((res) => {
          // Update react-table
          const url = window.URL.createObjectURL(new Blob([res.data]), { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'file.pdf'); // or any other extension
          document.body.appendChild(link);
          link.click();
          this.getGroupedOrders();
          // window.open(`data:application/pdf;base64,${Buffer.from(res.data).toString('base64')}`);
        });
    } else {
      const filteredOrders = row.orders.filter((order, index) => order.fulfilment_status === 'Preparing' && index <= 35);
      const itemsForUpdate = [];
      // console.log(itemsForUpdate);
      filteredOrders.map((order) => {
        order.packaging_fee = 0.30;
        order.order_fee = 1.00;

        let totalWeight = order.mm_weight * order.quantity;
        if (order.package_size === 'SP') {
          if (order.quantity > 2) {
            totalWeight += largePackage;
            order.packaging_fee = 0.60;
          } else {
            totalWeight += mediumPackage;
          }
        } else {
          totalWeight += smallPackage;
        }
        if (totalWeight > 1999 && isDomesticShipment(order.ship_to_country_code, order.ship_to_zip)) {
          order.shipping_service = 'TPS';
        }
        order.mm_weight = totalWeight;
        order.mm_package_size = order.package_size === 'LL' && totalWeight <= 749 ? 'LL' : 'SP';
        if (order.mm_package_size === 'SP') {
          order.packaging_fee = 0.60;
        }
        if (isDomesticShipment(order.ship_to_country_code, order.ship_to_zip)) {
          order.shipping_service = getDomesticServiceForSize(order.shipping_service, order.mm_package_size);
        }
        const servicePrice = getServicePrice(order.mm_weight, order.shipping_service, order.ship_to_country, order.mm_package_size);
        const mmPrice = getMMServicePrice(order.mm_weight, order.shipping_service, order.ship_to_country, order.mm_package_size);
        const shippingZone = getShippingZone(order.ship_to_country);

        order.shipping_zone = shippingZone;
        order.mm_shipping_cost = mmPrice;
        order.client_shipping_price = servicePrice;
        order.fee_vat = (order.packaging_fee + order.order_fee) * 0.2;
        if (isTaxable(order.ship_to_country)) {
          order.shipping_vat = order.client_shipping_price * 0.2;
        } else {
          order.shipping_vat = 0;
        }
        const country = countryList.find(ctry => ctry.label === order.ship_to_country);
        order.ship_to_countrycode = country.value;
        order.customsItems = [];

        const customsItem = {};
        // customsItem.itemName = order.item_name;

        // const nameCheck = order.item_name.toString().toLowerCase();
        // if (nameCheck.includes('cd')) {
        //   customsItem.itemDesc = 'CD';
        //   customsItem.itemHs = 8523492000;
        // } else if (nameCheck.includes('poster')) {
        //   customsItem.itemDesc = 'Poster';
        //   customsItem.itemHs = 4901990000;
        // } else if (nameCheck.includes('cassette')) {
        //   customsItem.itemDesc = 'Cassette Tape';
        //   customsItem.itemHs = 8523291900;
        // } else if (nameCheck.includes('shirt ')) {
        //   customsItem.itemDesc = 'T-Shirt';
        //   customsItem.itemHs = 6109100010;
        // } else if (nameCheck.includes('tee ')) {
        //   customsItem.itemDesc = 'T-Shirt';
        //   customsItem.itemHs = 6109100010;
        // } else if (nameCheck.includes('sweatshirt')) {
        //   customsItem.itemDesc = 'Sweatshirt';
        //   customsItem.itemHs = 6109100010;
        // } else {
        //   customsItem.itemDesc = 'Vinyl Record';
        //   customsItem.itemHs = 8523809000;
        // }
        customsItem.itemName = order.item_name;
        customsItem.itemOrigin = order.customs_origin;
        customsItem.itemDesc = order.customs_desc;
        customsItem.itemHs = order.hs_code;
        customsItem.itemQty = order.quantity;
        customsItem.itemPrice = order.price;
        customsItem.itemWeight = order.mm_weight;
        order.customsItems.push(customsItem);
      });
      const finalFilteredOrders = filteredOrders.filter((order, index) => !(!isDomesticShipment(order.ship_to_country_code, order.ship_to_zip) && order.mm_weight > 1999));
      finalFilteredOrders.map((groupOrder) => {
        if (!itemsForUpdate.some(item => item.package_id === groupOrder.package_id)) itemsForUpdate.push({ package_id: groupOrder.package_id, sku: groupOrder.sku, qty: 0 });
        itemsForUpdate.find(item => item.package_id === groupOrder.package_id).qty += groupOrder.quantity;
      });
      filteredOrders.map((item, index) => {
        item.batchPosition = index;
      });
      await axios.post(`${URL}/admin/bandcamp/orders/ship`, {
        orders: filteredOrders,
        items_to_update: itemsForUpdate,
      }, {
        headers: {
          Authorization: localStorage.getItem('mm_admin'),
          'Content-Type': 'application/json',
          Accept: 'application/pdf',
        },
        responseType: 'arraybuffer',
      })
        .then((res) => {
          // Update react-table
          const url = window.URL.createObjectURL(new Blob([res.data]), { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'file.pdf'); // or any other extension
          document.body.appendChild(link);
          link.click();
          this.getGroupedOrders();
          // window.open(`data:application/pdf;base64,${Buffer.from(res.data).toString('base64')}`);
        });
    }
    return true;
  }

  cancelFulfilment(order) {
    console.log('Cancelling');
    console.log(order.fulfilment_id);
    if (order.fulfilment_id !== undefined) {
      const postData = {
        orderId: order.fulfilment_id,
      };
      axios.post(`${URL}/admin/bandcamp/orders/fulfilment/cancel`, postData, { headers: { Authorization: localStorage.getItem('mm_admin') } })
        .then((response) => {
          const groupCopy = this.state.selectedGroup;
          const groupOrders = groupCopy.orders.filter(findOrder =>
            findOrder.fulfilment_id === response.data.id);
          groupOrders.map((groupOrder) => {
            groupOrder.fulfilment_status = undefined;
            groupOrder.fulfilment_id = undefined;
          });
          this.setState({ selectedGroup: groupCopy });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }


  generateAllOrderPDFs = () => {
    const pullSheet = this.state.groupedData.map(group => (
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.header}>
            AboveBoard PullSheet
          </Text>
          <Text style={styles.subHeader}>
            {new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={styles.subHeader}>
            {group.item}
          </Text>
          <Text style={styles.subHeader}>
            Number of copies to pull: {group.orders.map(order => order.quantity).reduce((prev, curr) => prev + curr, 0)}
          </Text>
        </View>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Customer</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Quantity</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Country</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Initials</Text>
            </View>
          </View>
          {group.orders.map(order => (
            <View style={styles.tableRow}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{order.ship_to_name}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{order.quantity}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{order.ship_to_country}</Text>
              </View>
              <View style={styles.tableCol} />
            </View>
          ))}
        </View>
      </Page>
    ));

    MyDoc = null;

    this.state.groupedData.map((group) => {
      this.setState({ selectedGroup: group });
      this.submitPrepareBatch(group);
    });

    MyDoc = (
      <Document title="Order">
        {pullSheet}
      </Document>
    );

    // const ordersToPrepare = [];
    // orders.map((order) => {
    //   ordersToPrepare.push(order.id);
    // });

    // this.submitPrepareBatch(orders);
    // this.forceUpdate();
  }

  generateOrderPDF = (group) => {
    const clientName = group.clientName || group.orders[0].clientName || group.orders[0].client_name || '';
    if (group.item === 'Multiple Items' || group.item === 'Multiple Items (Pre-Order)') {
      const orders = [];
      const grouped = group.orders.reduce((groups, order) => {
        if (group.orders.filter(filterOrder => filterOrder.payment_id === order.payment_id).length > 1) {
          if (!groups[order.payment_id]) groups[order.payment_id] = [];
          groups[order.payment_id].push(order);
        }
        return groups;
      }, {});

      Object.keys(grouped).forEach((key) => {
        orders.push(grouped[key]);
      });
      // const hasOptions = (!!group.orders[0].options);
      // console.log(group.orders[0].options);
      const pullSheet = (
        <View style={{ width: '100%' }}>
          <View style={styles.section}>
            <Text style={styles.header}>
              Bandcamp PullSheet
            </Text>
            <Text style={styles.subHeader}>
              {new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}
            </Text>
          </View>
          <View style={styles.section}>
            <Text style={styles.subHeader}>
              Multiple Item Orders
            </Text>
          </View>
          {orders.map(order => (
            <View>
              <View style={styles.multipleSplitSection} />
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Customer</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Total Quantity</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell} />
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Country</Text>
                  </View>
                </View>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{order[0].ship_to_name}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{order.map(orderCount => orderCount.quantity).reduce((prev, curr) => prev + curr, 0)}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{order[0].option_name}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{order[0].ship_to_country}</Text>
                  </View>
                </View>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Item</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Quantity</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>Option/Notes</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>SKU</Text>
                  </View>
                </View>
                {order.map(order2 => (
                  <View style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{order2.item_name}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{order2.quantity}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{order2.option_name}</Text>
                      <Text style={styles.tableCell}>{order2.ship_notes}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        {clientName ? `${clientName}\n` : ''}{order2.sku}{'\n'}{order2.mm_location}
                      </Text>
                    </View>
                  </View>
              ))}
              </View>
            </View>
        ))}
        </View>
      );

      MyDoc = null;

      MyDoc = (
        <Document title="Order">
          <Page size="A4" style={styles.page}>
            {pullSheet}
          </Page>
        </Document>
      );
      this.submitPrepareBatch(group);
      this.forceUpdate();
    } else {
      group.orders = group.orders.slice(0, 36);
      const hasOptions = Array.isArray(group.orders[0].options) && group.orders[0].options.length > 0;
      const pullSheet = (
        <View style={{ width: '100%' }}>
          <View style={styles.section}>
            <Text style={styles.header}>
              AboveBoard PullSheet
            </Text>
            <Text style={styles.subHeader}>
              {new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}
            </Text>
          </View>
          <View style={[styles.section, { width: '100%' }]}>
            <Text style={styles.subHeader}>
              {group.item}
            </Text>
            {clientName ? <Text style={styles.tableCell}>{clientName}</Text> : null}
            {hasOptions ?
              group.orders[0].options.map(option => (
                <Text style={styles.tableCell}>
                  {option.title}: {group.orders.filter(order => order.option_name === option.title)
                    .map(order => order.quantity).reduce((prev, curr) => prev + curr, 0)}
                  {' '}(sku: {option.sku ||
                    (group.orders.find(order => order.option_name === option.title) || group.orders[0]).sku})
                </Text>
              )) : <Text style={styles.tableCell}>SKU: {group.orders[0].sku}{'\n'}{group.orders[0].mm_location}</Text> }
            <Text style={styles.subHeader}>
              Number of items to pull: {group.orders.map(order => order.quantity).reduce((prev, curr) => prev + curr, 0)}
            </Text>
          </View>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Customer</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Quantity</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Option/Notes</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Country</Text>
              </View>
            </View>
            {group.orders.map(order => (
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{order.ship_to_name}</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{order.quantity}</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{order.option_name}</Text>
                  <Text style={styles.tableCell}>{order.ship_notes}</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>{order.ship_to_country}</Text>
                </View>
              </View>
          ))}
          </View>
        </View>
      );

      MyDoc = null;

      MyDoc = (
        <Document title="Order">
          <Page size="A4" style={styles.page}>
            {pullSheet}
          </Page>
        </Document>
      );

      this.submitPrepareBatch(group);
      this.forceUpdate();
    }
  }

  render() {
    const ordersColumns = [
      {
        Header: 'Address Issues',
        id: 'address_issues',
        Cell: row => (
          row.original.address_issues && row.original.address_issues.length > 0 ? (
            <span style={{ color: 'red', fontWeight: 600 }}>
              {row.original.address_issues.join(', ')}
            </span>
          ) : (
            <span style={{ color: 'green' }}>OK</span>
          )
        ),
      },
      {
        Header: 'Note',
        width: getColumnWidth(this.state.data, '', 'In Batch?'),
        accessor: 'ship_notes',
      }, {
        Header: 'FF Id',
        id: 'id',
        sortable: false,
        accessor: 'id',
        width: getColumnWidth(this.state.data, 'id', 'FF Id'),
      }, {
        Header: 'BC Id',
        id: 'bc_id',
        sortable: false,
        accessor: 'payment_id',
        width: getColumnWidth(this.state.data, 'bc_id', 'BC Id'),
      }, {
        Header: 'Order Date',
        id: 'order_date',
        filterable: false,
        width: getColumnWidth(this.state.data, 'order_date', 'Order Date'),
        Cell: row => (
          <div>
            <span>{new Date(row.original.order_date).toLocaleDateString()}</span>
          </div>
        ),
      }, {
        Header: 'Customer',
        id: 'ship_to_name',
        sortable: false,
        accessor: 'ship_to_name',
        width: getColumnWidth(this.state.data, 'ship_to_name', 'Customer'),
      }, {
        Header: 'Destination',
        id: 'ship_to_country',
        accessor: 'ship_to_country',
        width: getColumnWidth(this.state.data, 'ship_to_country', 'Destination'),

      }, {
        Header: 'Quantity',
        id: 'quantity',
        accessor: 'quantity',
        width: getColumnWidth(this.state.data, 'quantity', 'Quantity'),

      }, {
        Header: 'Payment State',
        id: 'payment_state',
        accessor: 'payment_state',
        width: getColumnWidth(this.state.data, 'payment_state', 'Payment State'),

      }, {
        Header: 'Fulfilment Status',
        id: 'fulfilment_status',
        width: getColumnWidth(this.state.data, 'fulfilment_status', 'Fulfilment Status'),
        Cell: row => (
          <div>
            {row.original.fulfilment_status === 'Preparing' ? (
              <tr>{row.original.fulfilment_status} (<a href="#" onClick={() => { this.cancelFulfilment(row.original); }}>Remove</a>)</tr>
                          ) : null }
          </div>
        ),

      },
    ];

    const groupedColumns = [
      {
        Header: 'Client',
        id: 'client',
        width: getColumnWidth(this.state.groupedData, 'clientName', 'Client'),
        accessor: d => d.clientName,
      }, {
        Header: 'Item',
        id: 'item',
        sortable: false,
        Cell: row => (
          <div>
            <span>{row.original.item}</span>
            <br />
            <span>{row.original.item === 'Multiple Items' ? '-' : row.original.orders[0].sku}</span>
            <br />
            <span>
              <b>{(row.original.orders.length > 1) ? `${row.original.orders.length} Orders `
              : `${row.original.orders.length} Order `}
               ({row.original.orders.map(order => order.quantity).reduce((prev, curr) => prev + curr, 0)} Items)
              </b>
              {row.original.orderType === 'Pre-Order' ? (
                <div>
                  <span>Release Date: {new Date(row.original.orders[0].release_date).toLocaleDateString()}</span>
                </div>
              ) : null }
            </span>
          </div>
        ),
      }, {
        Header: 'Pull Sheet',
        id: 'pull_sheet',
        sortable: false,
        width: getColumnWidth(this.state.data, 'pull_sheet', 'Pull Sheet'),
        Cell: row => (
          <div>
            {(row.original.orders.filter(filterOrder => filterOrder.fulfilment_status === 'Preparing').length > 0) ? (
              // <div>
              <SubmitBatchButton
                color="danger"
                title="Submit Batch"
                task={() => this.submitShipmentBatch(row.original)}
              />
              //   <br />
              //   <SubmitBatchButton
              //     color="danger"
              //     title="Submit DHL"
              //     task={() => this.submitShipmentBatch(row.original)}
              //   />
              // </div>
          ) :
              // <div>
              <Button
                color="primary"
                size="sm"
                onClick={() => this.generateOrderPDF(row.original)}
              >Generate Batch
              </Button>
              //   <br />
              //   // <Button
              //   //   color="primary"
              //   //   size="sm"
              //   //   onClick={() => this.generateOrderPDF(row.original)}
              //   // >Generate DHL
              //   // </Button>
              // </div>
               }
          </div>
        ),
      },
    ];

    return (
      <Col>
        <Card>
          <CardBody style={{ paddingBottom: 0 }}>
            <div
              style={{
                padding: 15,
                border: '1px solid #ddd',
                borderRadius: 5,
                marginBottom: 15,
                background: '#fafafa',
              }}
            >
              <h5 style={{ marginBottom: 15 }}>Advanced Filters</h5>
              <div className="row">
                <div className="col-md-3">
                  <label>Client</label>
                  <select
                    className="form-control"
                    value={this.state.advancedFilters.clientMode}
                    onChange={e => this.handleAdvancedFilterChange('clientMode', e.target.value)}
                    style={{ marginBottom: 6 }}
                  >
                    <option value="include">Include client</option>
                    <option value="exclude">Exclude client</option>
                  </select>
                  <select
                    className="form-control"
                    value={this.state.advancedFilters.clientId}
                    onChange={e => this.handleAdvancedFilterChange('clientId', e.target.value)}
                  >
                    <option value="">All Clients</option>
                    {this.state.clients.map(client => (
                      <option key={client.id} value={client.id}>
                        {client.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label>SKU</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.advancedFilters.sku}
                    onChange={e => this.handleAdvancedFilterChange('sku', e.target.value)}
                  />
                  <label style={{ marginTop: 10 }}>Payment ID</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.advancedFilters.paymentId}
                    onChange={e => this.handleAdvancedFilterChange('paymentId', e.target.value)}
                  />
                  <label style={{ marginTop: 10 }}>Shipping Note</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.advancedFilters.shippingNote}
                    onChange={e => this.handleAdvancedFilterChange('shippingNote', e.target.value)}
                  />
                </div>
              </div>
              <div
                className="row"
                style={{ marginTop: 15 }}
              >
                <div className="col-md-2">
                  <label>Min Qty</label>
                  <input
                    type="number"
                    className="form-control"
                    value={this.state.advancedFilters.quantityMin}
                    onChange={e => this.handleAdvancedFilterChange('quantityMin', e.target.value)}
                  />
                </div>
                <div className="col-md-2">
                  <label>Max Qty</label>
                  <input
                    type="number"
                    className="form-control"
                    value={this.state.advancedFilters.quantityMax}
                    onChange={e => this.handleAdvancedFilterChange('quantityMax', e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label>WAIT Notes</label>
                  <select
                    className="form-control"
                    value={this.state.advancedFilters.waitNoteMode}
                    onChange={e => this.handleAdvancedFilterChange('waitNoteMode', e.target.value)}
                  >
                    <option value="hide">Hide WAIT orders</option>
                    <option value="only">Only WAIT orders</option>
                    <option value="include">Include WAIT orders</option>
                  </select>
                </div>
                <div
                  className="col-md-4"
                  style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                  }}
                >
                  <Button
                    color="secondary"
                    onClick={() => {
                      this.setState({
                        advancedFilters: {
                          clientId: '',
                          labelId: '',
                          quantityMin: '',
                          quantityMax: '',
                          sku: '',
                          paymentId: '',
                          shippingNote: '',
                          waitNoteMode: 'hide',
                        },
                      }, () => {
                        this.getGroupedOrders();
                      });
                    }}
                  >
                    Reset Filters
                  </Button>
                </div>
              </div>
            </div>
            <PDFDownloadLink
              className="btn btn-primary"
              document={MyDoc}
              fileName="ABDPullSheet.pdf"
            >
              {({
              loading,
            }) => (loading ? 'Loading document...' : 'Download')}
            </PDFDownloadLink>
            <ReactTable
              data={this.state.groupedData}
              columns={groupedColumns}
              showPagination={false}
              className="-striped -highlight -responsive"
              filterable
              defaultPageSize={200}
              defaultFiltered={[
                {
                  id: 'order_type',
                  value: 'Ready',
                },
              ]}
              getTrProps={(state, rowInfo) => {
                if (rowInfo !== undefined) {
                  return {
                  onClick: (e) => {
                    console.log(rowInfo.original);
                  this.setState({
                  selectedGroup: rowInfo.original,
                  selected: undefined,
                  data: rowInfo.original.orders,
                });
                    },
                    style: {
                    background: rowInfo.original === this.state.selectedGroup ? '#00afec' : 'white',
                    color: rowInfo.original === this.state.selectedGroup ? 'white' : 'black',
                  },
                };
              }
              return {};
              }}
              style={{
                height: '400px',
              }}
            />
            <ReactTable
              style={{
                height: '400px',
              }}
              data={this.state.data} // should default to []
              columns={ordersColumns}
              pages={this.state.pages} // should default to -1 (which means we don't know how many pages we have)
              loading={this.state.loading}
              manual
              filterable
              multiSort={false}
              defaultPageSize={250}
              defaultSorted={[
                {
                  id: 'order_date',
                  desc: true,
                },
              ]}
              className="-striped -highlight -responsive"
              getTrProps={(state, rowInfo) => {
                  if (rowInfo !== undefined) {
                    return {
                      onClick: () => {
                        const currentShipment = this.state.shipmentBatch.find(shipment =>
                          shipment.fulfillmentId === rowInfo.original.id);
                        this.setState({
                          selected: rowInfo.original,
                          // selectedActWeight: currentShipment ? currentShipment.weight : '',
                          // selectedSize: currentShipment ? currentShipment.actual_size : rowInfo.original.package_size,
                          // selectedMMPrice: currentShipment ? currentShipment.mm_shipping_cost : 0,
                          // selectedActualPrice: currentShipment ? currentShipment.actual_shipping_price : 0,
                        });
                        console.log('FINDME');
                        console.log(rowInfo.original);
                      },
                      style: {
                        background: rowInfo.original === this.state.selected ? '#00afec' : 'white',
                        color: rowInfo.original === this.state.selected ? 'white' : 'black',
                      },
                    };
                  }
                    return {};
                }} // informs React Table that you'll be handling sorting and pagination server-side
            />
            {this.state.selected !== undefined ? (
              <CardDeck>
                <Card>
                  <CardBody>
                    <div className="project-summary">
                      <div className="card__title">
                        <h5 className="bold-text">{`${this.state.selected.external_order_id}`}</h5>
                      </div>
                      <div className="project-summary__stats">
                        <div className="project-summary__stat">
                          <table className="project-summary__info">
                            <tbody>
                              <tr>
                                <th>Order Date:</th>
                                <td>
                                  {new Date(this.state.selected.order_date).toLocaleString()}
                                </td>
                              </tr>

                              <tr>
                                <th>Order Value:</th>
                                <td>{currencyFormat.format(this.state.selected.sub_total)}</td>
                              </tr>

                              <tr>
                                <th>Buyer Note:</th>
                                <td>
                                  <b>{this.state.selected.buyer_notes || '-'}</b>
                                </td>
                              </tr>

                              <tr>
                                <th>Shipping Note:</th>
                                <td>
                                  <b>{this.state.selected.ship_notes || '-'}</b>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="project-summary__stat">
                          <table className="project-summary__info">
                            <tbody>
                              {/* <tr>
                                <th>Shipping Address:</th>
                                <td>{this.getShippingAddress()}</td>
                              </tr> */}
                              {this.state.selected.address_issues && this.state.selected.address_issues.length > 0 ? (
                                <tr>
                                  <th>Address Issues:</th>
                                  <td style={{ color: 'red', fontWeight: 600 }}>
                                    {this.state.selected.address_issues.map((issue, index) => (
                                      <div key={index}>{issue}</div>
                                    ))}
                                  </td>
                                </tr>
                              ) : null}
                              <tr>
                                <th>Name:</th>
                                <td>
                                  {this.state.isEditing ? (
                                    <input
                                      type="text"
                                      value={this.state.selected.ship_to_name || ''}
                                      onChange={e => this.handleSelectedAddressChange('ship_to_name', e.target.value)}
                                    />
                                  ) : (
                                    this.state.selected.ship_to_name
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th>Address 1:</th>
                                <td>
                                  {this.state.isEditing ? (
                                    <input
                                      type="text"
                                      value={this.state.selected.ship_to_street || ''}
                                      onChange={e => this.handleSelectedAddressChange('ship_to_street', e.target.value)}
                                    />
                                  ) : (
                                    this.state.selected.ship_to_street
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th>Address 2:</th>
                                <td>
                                  {this.state.isEditing ? (
                                    <input
                                      type="text"
                                      value={this.state.selected.ship_to_street_2 || ''}
                                      onChange={e => this.handleSelectedAddressChange('ship_to_street_2', e.target.value)}
                                    />
                                  ) : (
                                    this.state.selected.ship_to_street_2
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th>City:</th>
                                <td>
                                  {this.state.isEditing ? (
                                    <input
                                      type="text"
                                      value={this.state.selected.ship_to_city || ''}
                                      onChange={e => this.handleSelectedAddressChange('ship_to_city', e.target.value)}
                                    />
                                  ) : (
                                    this.state.selected.ship_to_city
                                  )}
                                </td>
                              </tr>
                              {this.state.selected.shipping_address_region ? (
                                <tr>
                                  <th>County:</th>
                                  <td>{this.state.selected.shipping_address_region}</td>
                                </tr>
                              ) : null }
                              <tr>
                                <th>State/County:</th>
                                <td>
                                  {this.state.isEditing ? (
                                    <input
                                      type="text"
                                      value={this.state.selected.ship_to_state || ''}
                                      onChange={e => this.handleSelectedAddressChange('ship_to_state', e.target.value)}
                                    />
                                  ) : (
                                    this.state.selected.ship_to_state
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th>Postcode:</th>
                                <td>
                                  {this.state.isEditing ? (
                                    <input
                                      type="text"
                                      value={this.state.selected.ship_to_zip || ''}
                                      onChange={e => this.handleSelectedAddressChange('ship_to_zip', e.target.value)}
                                    />
                                  ) : (
                                    this.state.selected.ship_to_zip
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th>Country:</th>
                                <td>{this.state.selected.ship_to_country}</td>
                              </tr>
                              <Button
                                color="primary"
                                size="sm"
                                onClick={() => this.copyShippingAddressToClipboard()}
                              >Copy Address
                              </Button>
                              <Button
                                color={this.state.isEditing ? 'success' : 'primary'}
                                size="sm"
                                onClick={() => this.setState(prevState => ({
                                  isEditing: !prevState.isEditing,
                                }))}
                              >
                                {this.state.isEditing ? 'Done Editing' : 'Edit Address'}
                              </Button>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <hr />
                    </div>
                  </CardBody>
                </Card>
              </CardDeck>) : null }
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(OpenOrdersTable);
